import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

// Define a service using a base URL and expected endpoints
export const storeApi = createApi({
    reducerPath: 'storeApi',
    baseQuery: fetchBaseQuery({
        baseUrl: 'https://onza-api.ibm.kg/api/store/',
        prepareHeaders: (headers, { getState }) => {
            let { auth: { auth } } = getState();
            if (typeof auth == "string") {
                auth = JSON.parse(auth);
            }
            headers.set("Authorization", `Bearer ${auth?.accessToken}`);
            return headers;
        },
    }),
    tagTypes: ["store"],
    endpoints: (builder) => ({
        getStore: builder.query({
            query: () => `storeList`,
            providesTags: ["store"],
        }),
        createEditStore: builder.mutation({
            query: (budy) => {
                const formdata = new FormData();
                formdata.append("name", budy.name);
                formdata.append("country_guid", budy.country_guid);
                formdata.append("category_guid", budy.category_guid);
                formdata.append("min_cost", budy.min_cost);
                formdata.append("max_cost", budy.max_cost);
                formdata.append("store_guid", budy.guid);
                formdata.append("link", budy.link);
                formdata.append("logo", budy.logo);
                return {
                    url: "createEditStore",
                    method: "POST",
                    body: formdata
                }
            },
            invalidatesTags: ['store'],
        }),
        deleteStore: builder.mutation({
            query: (guid) => {
                return {
                    url: "deleteStore",
                    method: "DELETE",
                    params: {
                        store_guid: guid
                    },
                }
            },
            invalidatesTags: ['store'],
        })
    }),
})

export const { useGetStoreQuery, useCreateEditStoreMutation, useDeleteStoreMutation } = storeApi